// extracted by mini-css-extract-plugin
export default {"container":"PX-z","starLabel":"QX-z"};